import script from "./CompanyCommonComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyCommonComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyCommonComponent.vue?vue&type=style&index=0&id=1fde3e16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fde3e16"]])

export default __exports__